module.exports = __webpack_public_path__ + "img/kone-lift-lg.b3b9489e.svg";